import { render, staticRenderFns } from "./OldUploadFile.vue?vue&type=template&id=e0b05f5c&scoped=true&"
import script from "./OldUploadFile.vue?vue&type=script&lang=js&"
export * from "./OldUploadFile.vue?vue&type=script&lang=js&"
import style0 from "./OldUploadFile.vue?vue&type=style&index=0&id=e0b05f5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b05f5c",
  null
  
)

export default component.exports